import { TransferRequestStatus, TransferRequestType } from 'api/bdo/transfer-requests';

export const getColorForStatus = (status: TransferRequestStatus) => {
  switch (status) {
    case 'completed':
      return '#4ab682';
    case 'declined':
      return '#f5222d';
    case 'cancelled':
      return '#202c46';
    default:
      return '#2665ee';
  }
};

export const TransferRequestTypeLabels: Record<TransferRequestType, string> = {
  'BR-PT': 'BRC Points Transfer',
  'BR-SMAC': 'BRC to SMAC',
  'BR-CashCred': 'BRC to Cash Credit',
  'CC-BRCP': 'Credit Card to BRC Points',
  'CC-CashCred': 'Credit Card to Cash Credit',
  'CC-SMAC': 'Credit Card to SMAC',
  'CC-HOPE': 'Credit Card to HOPE Donation',
  airmile: 'Airmile',
  hotel_loyalty: 'Hotel Loyalty',
  membership_fee: 'Membership Fee Waiver',
  paper: 'Paper',
  evoucher: 'E-Voucher',
  cash_credit: 'Cash Credit'
};

type AccountType = 'BRC' | 'SMAC' | 'CC' | 'HOPE';

export const TransferRequestAccountTypes: Record<TransferRequestType, [AccountType, AccountType]> =
  {
    'BR-PT': ['BRC', 'BRC'],
    'BR-SMAC': ['BRC', 'SMAC'],
    'BR-CashCred': ['BRC', 'CC'],
    'CC-BRCP': ['CC', 'BRC'],
    'CC-CashCred': ['CC', 'CC'],
    'CC-SMAC': ['CC', 'SMAC'],
    'CC-HOPE': ['CC', 'HOPE'],
    airmile: ['BRC', 'BRC'],
    hotel_loyalty: ['BRC', 'BRC'],
    membership_fee: ['BRC', 'BRC'],
    paper: ['BRC', 'BRC'],
    evoucher: ['BRC', 'BRC'],
    cash_credit: ['BRC', 'BRC']
  };
